<app-filter-panel [fields]="fieldsConfig" [quickSearchFilter]="quickSearchField"
    quickSearchPlaceholder="Expediente" (search)="search()"></app-filter-panel>

<!--
<div>
<div class="flex gap-2">
    <div class="input-field" style="width: 150px;">
        <label for="companyId">Compañía</label>
        <p-multiSelect [options]="companies" [(ngModel)]="filters.companyId.value"
          [ngModelOptions]="{standalone: true}" optionLabel="name" optionValue="id" placeholder="Compañía"
          showClear appendTo="body" (onChange)="companyChanged()" (onClear)="companyChanged()"></p-multiSelect>
    </div>
    <div class="input-field" style="width: 150px;">
        <label for="contractId">Contrato</label>
        
        <p-multiSelect [options]="contracts" [(ngModel)]="filters.contractId.value"
          [ngModelOptions]="{standalone: true}" optionLabel="name" optionValue="id" placeholder="Contrato"
          showClear appendTo="body" (onChange)="search()" (onClear)="search()"></p-multiSelect>
    </div>
    <div class="input-field" style="width: 150px;">
        <label for="caseModeId">Tipo</label>
        <p-multiSelect [(ngModel)]="filters.caseModeId.value" [options]="caseModes" optionLabel="name" optionValue="id" appendTo="body"
            [ngModelOptions]="{standalone: true}" showClear appendTo="body" (onChange)="search()" 
            [filter]="true" filterBy="name" placeholder="Tipo" (onChange)="search()" d-form-field-error></p-multiSelect>
    </div>
    <span class="input-field p-input-icon-right">
        <label for="caseNumber">Expediente</label>
        <input pInputText placeholder="Expediente" [(ngModel)]="filters.caseNumber.value" (keydown.enter)="search()"
            class="w-full" />
        <i *ngIf="filters.caseNumber.value" class="pi pi-times cursor-pointer"
            (click)="filters.caseNumber.value = null; search()"></i>
    </span>
    <div class="input-field" style="width: 150px;">
        <label for="caseStateId">Estado</label>

        <p-multiSelect [options]="casesStates" [(ngModel)]="filters.caseStateId.value"
          [ngModelOptions]="{standalone: true}" optionLabel="name" optionValue="id" placeholder="Estado"
          showClear appendTo="body" (onChange)="search()" (onClear)="search()"></p-multiSelect>
        <!- -<p-dropdown placeholder="Estado" [options]="casesStates" optionLabel="name" optionValue="id"
            [(ngModel)]="filters.caseStateId.value" (onChange)="search()" showClear />- ->
    </div>
    <div class="input-field" style="width: 150px;">
        <label for="caseTypeId">Tipo de daño</label>
        <p-dropdown placeholder="Tipo de daño" [options]="casesTypes" optionLabel="name" optionValue="id"
            [(ngModel)]="filters.caseTypeId.value" (onChange)="search()" showClear />
    </div>
    <div class="input-field" style="width: 150px;">
        <label for="processorId">Tramitador</label>
        <!- -<p-dropdown placeholder="Tramitador" [options]="processors" optionLabel="name" optionValue="id"
            [(ngModel)]="filters.processorId.value" (onChange)="search()" showClear />- ->

        <p-multiSelect [options]="processors" [(ngModel)]="filters.processorId.filters[0].value"
          [ngModelOptions]="{standalone: true}" optionLabel="name" optionValue="id" placeholder="Tramitador" (onChange)="search()" (onClear)="search()"
          showClear appendTo="body"></p-multiSelect>
    </div>
    <div class="input-field" style="width: 150px;">
        <label for="processorId">Técnico</label>
        <!- -<p-dropdown placeholder="Técnico" [options]="technicians" optionLabel="name" optionValue="id"
            [(ngModel)]="filters.technicianId.filter.value" (onChange)="search()" showClear />- ->
        <p-multiSelect [options]="technicians" [(ngModel)]="filters.technicianId.filter.value"
          [ngModelOptions]="{standalone: true}" optionLabel="name" optionValue="id" placeholder="Técnico" (onChange)="search()" (onClear)="search()"
          showClear appendTo="body"></p-multiSelect>
    </div>
   
    <span class="input-field p-input-icon-right">
        <label for="notificationNumber">Nº Servicio</label>
        <input pInputText placeholder="Nº Servicio" [(ngModel)]="filters.notificationNumber.filter.value"
            (keydown.enter)="search()" class="w-full" />
        <i *ngIf="filters.notificationNumber.filter.value" class="pi pi-times cursor-pointer" 
            (click)="filters.notificationNumber.filter.value = null; search()"></i>
    </span>
    <div class="input-field" style="width: 150px;">
        <label for="serviceTypeId">Tipo de servicio</label>
        <p-dropdown placeholder="Tipo de servicio" [options]="servicesTypes" optionLabel="name" optionValue="id"
            [(ngModel)]="filters.serviceTypeId.filter.value" (onChange)="search()" showClear />
    </div>
    <div class="input-field" style="width: 150px;">
        <label for="caseTreatmentId">Tratamiento</label>
        <p-dropdown placeholder="Tratamiento" [options]="casesTreatments" optionLabel="name" optionValue="id"
            [(ngModel)]="filters.caseTreatmentId.value" (onChange)="search()" showClear />
    </div>
    <div class="input-field">
        <label for="isRecapture">Reapertura</label>
        <p-dropdown placeholder="Reapertura" [options]="isRecaptureOptions" optionLabel="label" optionValue="value"
            [(ngModel)]="filters.isRecapture.value" (onChange)="search()" [showClear]="false" />
    </div>
</div>
<div class="mt-2 flex gap-2">
    <div class="input-field" style="max-width:134px">
        <label for="dateFrom">Revisión desde</label>
        <p-calendar [firstDayOfWeek]="1" [(ngModel)]="filters.revisionDateFrom.value" [showIcon]="true" [showTime]="false" [hourFormat]="'24'" dateFormat="dd/mm/yy"
            d-form-field-error appendTo="body"></p-calendar>
    </div>
    <div class="input-field" style="max-width:134px">
        <label for="dateTo">Revisión hasta</label>
        <p-calendar [firstDayOfWeek]="1" [(ngModel)]="filters.revisionDateTo.value" [showIcon]="true" [showTime]="false" [hourFormat]="'24'" dateFormat="dd/mm/yy"
            d-form-field-error appendTo="body"></p-calendar>
    </div>
    
    <div class="input-field p-input-icon-right">
        <label for="clientPolicy">Nº Póliza</label>
        <input pInputText placeholder="Nº Póliza" [(ngModel)]="filters.clientPolicy.value" (keydown.enter)="search()"
            class="w-full" />
        <i *ngIf="filters.clientPolicy.value" class="pi pi-times cursor-pointer"
            (click)="filters.clientPolicy.value = null; search()"></i>
    </div>
    <div class="input-field p-input-icon-right"  style="width: 150px;">
        <label for="insuranceCompanyId">Compañía aseguradora</label>
        <p-dropdown [(ngModel)]="filters.insuranceCompanyId.value" [options]="insuranceCompanies" optionLabel="name" optionValue="id"
            [filter]="true" filterBy="name" placeholder="Selecciona una compañía aseguradora" showClear (onChange)="search()" ></p-dropdown>
    </div>
     <div class="input-field p-input-icon-right" style="max-width: 105px;">
        <label for="clientName">Asegurado</label>
        <input pInputText placeholder="Asegurado" [(ngModel)]="filters.clientName.value" (keydown.enter)="search()"
            class="w-full" />
        <i *ngIf="filters.clientName.value" class="pi pi-times cursor-pointer"
            (click)="filters.clientName.value = null; search()"></i>
    </div>
    <div class="input-field p-input-icon-right" style="max-width: 105px;">
        <label for="clientphone">Tlf aseg</label>
        <input pInputText placeholder="Teléfono" [(ngModel)]="filters.clientphone.filters[0].value" (keydown.enter)="search()"
            class="w-full" />
        <i *ngIf="filters.clientphone.filters[0].value" class="pi pi-times cursor-pointer"
            (click)="filters.clientphone.filters[0].value = null; search()"></i>
    </div>
    <div class="input-field p-input-icon-right" style="max-width: 200px;">
        <label for="clientEmail">Email Aseg</label>
        <input pInputText placeholder="Email" [(ngModel)]="filters.clientEmail.value" (keydown.enter)="search()"
            class="w-full" />
        <i *ngIf="filters.clientEmail.value" class="pi pi-times cursor-pointer"
            (click)="filters.clientEmail.value = null; search()"></i>
    </div>
    
     <div class="input-field p-input-icon-right" style="max-width: 200px;">
        <label for="caseAddress">Dirección</label>
        <input pInputText placeholder="Dirección" [(ngModel)]="filters.caseAddress.value" (keydown.enter)="search()"
            class="w-full" />
        <i *ngIf="filters.caseAddress.value" class="pi pi-times cursor-pointer"
            (click)="filters.caseAddress.value = null; search()"></i>
    </div>
    <div class="input-field p-input-icon-right" style="max-width: 100px;">
        <label for="caseZity">Ciudad</label>
        <input pInputText placeholder="Ciudad" [(ngModel)]="filters.caseZity.value" (keydown.enter)="search()"
            class="w-full" />
        <i *ngIf="filters.caseZity.value" class="pi pi-times cursor-pointer"
            (click)="filters.caseZity.value = null; search()"></i>
    </div>
    <div class="input-field p-input-icon-right" style="max-width: 100px;">
        <label for="caseZipCode">Cod.Postal</label>
        <input pInputText placeholder="Cod.Postal" [(ngModel)]="filters.caseZipCode.value" (keydown.enter)="search()"
            class="w-full" />
        <i *ngIf="filters.caseZipCode.value" class="pi pi-times cursor-pointer"
            (click)="filters.caseZipCode.value = null; search()"></i>
    </div>
    
    <div class="input-field" style="width: 150px;">
        <label for="countriesRegions">Provincia</label>
        <p-dropdown placeholder="Provincias" [options]="countriesRegions" optionLabel="name" optionValue="id"
            [(ngModel)]="filters.countryRegionId.value" (onChange)="search()" showClear />
    </div>
    
    <div class="input-field" style="width: 150px;">
        <label for="pendingCapabilityId" style="margin-right: 8px;">Gremio</label>
        <p-dropdown placeholder="Especialidad pendiente" [options]="capabilities" optionLabel="name" optionValue="id"
            [(ngModel)]="filters.pendingCapabilityId.value" (onChange)="search()" showClear />
    </div>
    <div class="input-field">
        <label for="isUrgent" style="margin-right: 8px;">Urgentes</label>
        <p-checkbox [(ngModel)]="filters.isUrgent.value" [binary]="true" id="isUrgent"
            (onChange)="search()" d-form-field-error></p-checkbox>
    </div>
    <div class="input-field">
        <label for="withoutCompany" style="margin-right: 8px;">Sin compañía</label>
        <p-checkbox [(ngModel)]="filters.withoutCompany.filters[0].allowNull" [binary]="true"
            (onChange)="noCompanySelected($event)" d-form-field-error></p-checkbox>
    </div>
    <div class="input-field">
        <label for="caseNotStateFinal" style="margin-right: 8px;">Sólo activos</label>
        <p-checkbox [(ngModel)]="filters.caseNotStateFinal.value" [binary]="true"  id="caseNotStateFinal"
            (onChange)="search()" d-form-field-error></p-checkbox>
    </div>
    <div class="input-field">
        <label for="withoutProcessorId" style="margin-right: 8px;">Sin tramitador</label>
        <p-checkbox [(ngModel)]="filters.processorId.filters[1].allowNull" [binary]="true"  id="withoutProcessorId"
            (onChange)="noProcessorSelected($event)" d-form-field-error></p-checkbox>
    </div>

    <div class="input-field">
        <label for="isPrecite" style="margin-right: 8px;">Precita</label>
        <p-checkbox [(ngModel)]="filters.isPrecite.value" [binary]="true" id="isPrecite"
            (onChange)="search()" d-form-field-error></p-checkbox>
    </div>
    
    <div class="input-field">
        <label for="caseServicesId" style="margin-right: 8px;">Sin citas</label>
        <p-checkbox [(ngModel)]="filters.caseServicesId.value" [binary]="true"  id="caseServicesId"
            (onChange)="search()" d-form-field-error></p-checkbox>
    </div>
    
    <div class="input-field flex">
        <button pButton ngClass="mt-3" label="Buscar" icon="pi pi-search" (click)="search()"></button>
        <button pButton ngClass="mt-3 ml-2" label="Limpiar" icon="pi pi-eraser" (click)="clearFilters()" severity="secondary" ></button>
    </div>
</div>
</div>
-->

<p-table styleClass="small" #grid [value]="cases" [lazy]="true" (onLazyLoad)="loadData($event)" [loading]="loading"
    [paginator]="true" [rows]="25" [totalRecords]="totalRecords" [showCurrentPageReport]="true"
    currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
    [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex" [(selection)]="selectedCases"
    [sortField]="getSortField()" [sortOrder]="getSortOrder()"
    paginatorDropdownAppendTo="body">
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th *ngIf="allowAssignProcessor" style="width: 40px;">
                <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
            </th>
            <th pSortableColumn="contract.code">Contrato <p-sortIcon field="contract.code"></p-sortIcon></th>
            <th pSortableColumn="caseNumber">Expediente <p-sortIcon field="caseNumber"></p-sortIcon></th>
            <th pSortableColumn="caseState.name">Estado <p-sortIcon field="caseState.name"></p-sortIcon></th>
            <th pSortableColumn="caseType.name">Tipo <p-sortIcon field="caseType.name"></p-sortIcon></th>
            <th pSortableColumn="processor.name">Tramitador <p-sortIcon field="processor.name"></p-sortIcon></th>
            <th pSortableColumn="caseDate">Fecha <p-sortIcon field="caseDate"></p-sortIcon></th>
            <th pSortableColumn="caseDate">Días abierto<p-sortIcon field="caseDate"></p-sortIcon></th>
            <th pSortableColumn="lastActionDate">Días sin actualizar<p-sortIcon field="lastActionDate"></p-sortIcon></th>
            <th pSortableColumn="revisionDate">Fecha revisión <p-sortIcon field="revisionDate"></p-sortIcon></th>
            <th pSortableColumn="firstServiceTypeName" width="120">Tipos de servicio <p-sortIcon field="firstServiceTypeName"></p-sortIcon></th>
            <th pSortableColumn="caseExperts" width="50">Perito <p-sortIcon field="caseExperts"></p-sortIcon></th>
            <th pSortableColumn="companyWorkInProgress" width="50">Obra <p-sortIcon field="companyWorkInProgress"></p-sortIcon></th>
            <th pSortableColumn="budgetOrder" width="50">Ppto. <p-sortIcon field="budgetOrder"></p-sortIcon></th>
            <th pSortableColumn="invoice" width="50">Fact. <p-sortIcon field="invoice"></p-sortIcon></th>
            <th width="100"></th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-case let-columns="columns">
        <tr class="fila-clicable" (dblclick)="edit(case)" (mouseenter)="selectedCase=case" [pSelectableRow]="case">
            <td *ngIf="allowAssignProcessor">
                <p-tableCheckbox [value]="case"></p-tableCheckbox>
            </td>
            <td>
                <span *ngIf="case.contractId != null">{{case.contract?.code}}</span>
                <span class="text-danger" *ngIf="case.contractId == null">Sin contrato</span>
            </td>
            <td>
                <div class="flex gap-1">
                    <span [ngStyle]="{'color':case.caseTreatment?.backgroundColor}" [pTooltip]="case.caseTreatment?.name" tooltipPosition="top">
                        <icon [ngClass]="case.caseTreatment?.icon" style="font-size: 11px;"></icon>
                    </span>
                    <span *ngIf="case.incidentsStatus=='error'" [pTooltip]="'Expediente con incidencias de compañia'" tooltipPosition="top">
                        <i class="pi pi-exclamation-triangle text-danger" style="font-size: 11px;"></i>
                    </span>
                    <a [routerLink]="['/cases/', case.id]" [pTooltip]="tooltipContent" tooltipPosition="top">{{case.caseNumber}}</a>
                </div>
                <div class="flex gap-1">
                    <span *ngIf="case.isRecapture" class="p-tag p-tag-warn">R</span>
                    <span *ngIf="case.isVIP" class="p-tag p-tag-danger">VIP</span>
                    <span *ngIf="case.isUrgent" class="p-tag p-tag-danger">URG</span>
                    <span *ngIf="case.isPrecite" class="p-tag p-tag-danger">Preci</span>
                </div>
            </td>
            <td>
                <span class="p-tag" [style.backgroundColor]="case.caseState?.backgroundColor"
                    [style.foregroundColor]="case.caseState?.foregroundColor">
                    <span class="p-tag-label">{{case.caseState?.name}}</span>
                </span>
            </td>
            <td>{{(case.caseType!=null?case.caseType?.name:'Sin definir')}}</td>
            <td>
                <label [ngClass]="case.processor?.absence ? 'text-danger' : ''">
                {{(case.processor!=null?case.processor?.name:'Sin definir')}}</label>
            </td>
            <td>
                {{case.caseDate | date: 'dd/MM/yyyy HH:mm:ss'}}
                <br  *ngIf="case.recaptureDate">
                <small *ngIf="case.recaptureDate">R: {{case.recaptureDate | date: 'dd/MM/yyyy HH:mm'}}</small>
            </td>
            <!--<td>{{case.client?.name}}</td>
            <td>{{case.address?.fullAddress}}</td> -->
            <td>
                <div *ngIf="case.recaptureDate==null">{{getTimeAgo(case.caseDate)}}</div>
                <div *ngIf="case.recaptureDate!=null">{{getTimeAgo(case.recaptureDate)}} ({{getTimeAgo(case.caseDate)}})</div>
            </td>
            <td>{{getTimeAgo(case.lastActionDate)}}</td>
            <td>
                <span [ngClass]="getRevisionDateClass(case.revisionDate)">
                    {{ case.revisionDate | date: 'dd/MM/yyyy' }}
                </span>
            </td>                 
            <td>
                <div *ngIf="case.caseServiceTypes.length > 0">
                    <span *ngFor="let caseServiceType of case.caseServiceTypes; let i = index">
                        <span *ngIf="i>0">, </span>{{caseServiceType.serviceType.name}}
                    </span>
                </div>
            </td>       
            <td>
                <!--<i class="pi pi-users" *ngIf="case.expertStatus!=null" [pTooltip]="case.expertTooltip"></i> -->
                <small>{{case.expertTooltip}}</small>
            </td>
            <td>{{case.companyWorkInProgress | currency:'EUR':'symbol':'1.2-2' }}</td>
            <td>
                <i class="pi pi-file text-white p-1 border-round" *ngIf="getBudgetTransactionStatusColor(case) as color"
                    [ngClass]="color"></i>
            </td>            
            <td>
                <i class="pi pi-file text-white p-1 border-round" *ngIf="getInvoiceTransactionStatusColor(case) as color"
                    [ngClass]="color"></i>
            </td>            
            <td>
                <div class="flex gap-2 justify-content-end">
                    <a *ngIf="allowDelete" (click)="delete(case)" class="p-button p-button-rounded p-button-danger accion-fila"><i
                            class="pi pi-trash"></i></a>
                </div>
            </td>
        </tr>
    </ng-template>
</p-table>

<ng-template #tooltipContent>
    <div *ngIf="selectedCase && selectedCase.client">
        <b>{{selectedCase.client?.name}}</b><br>
        <span *ngIf="selectedCase.address">{{selectedCase.address?.fullAddress}}</span><br>
        <span *ngIf="selectedCase.client?.phone1">{{selectedCase.client?.phone1}}</span> <span *ngIf="selectedCase.client?.phone2">{{selectedCase.client?.phone2}}</span><br>
        <span>Tratamiento: <b>{{selectedCase.caseTreatment?.name}}</b></span>
    </div>
    <div *ngIf="selectedCase && selectedCase.client==null">
        Sin datos de cliente
    </div>
</ng-template>

<p-dialog header="Seleccione un tramitador" [(visible)]="displayProcessorModal" [modal]="true" [closable]="false"
    [style]="{width: '400px'}">
    <div class="input-field">
        <label for="date">Tramitador</label>
        <p-dropdown [options]="processors" [(ngModel)]="processorId" optionLabel="name" optionValue="id" 
            appendTo="body" [filter]="true" showClear (onFilter)="loadProcessors($event)"></p-dropdown>
    </div>

    <ng-template pTemplate="footer">
        <button pButton label="Cancelar" icon="pi pi-times" class="p-button-secondary"
            (click)="displayProcessorModal=false;"></button>
        <button pButton label="Asignar" icon="pi pi-check" (click)="saveProcessor()"></button>
    </ng-template>
</p-dialog>

<p-confirmDialog></p-confirmDialog>